module.exports = __webpack_public_path__ + "img/call-user--default-avator.9aa4dd75.svg";